export const getAudioTransceiversSenders = peerConnection =>
  peerConnection.getTransceivers()
    .filter(transceiver => transceiver.sender.track?.kind === 'audio')
    .map(({ sender }) => sender);

export const canModifySenderParameters = peerConnection =>
  peerConnection.getTransceivers().some(transceiver =>
    !!transceiver.sender?.getParameters && !!transceiver.sender?.setParameters);

export const canNegotiateHeaderExtensions = peerConnection =>
  peerConnection.getTransceivers().some(transceiver =>
    !!transceiver.getHeaderExtensionsToNegotiate && !!transceiver.setHeaderExtensionsToNegotiate);
